<template>
  <router-view />
</template>

<script setup>

</script>

<style>
:root {
  color-scheme: light;
  --yoj-bg: #f5f5f4;
  --yoj-surface: #ffffff;
  --yoj-surface-soft: #f5f5f4;
  --yoj-border: #d6d3d1;
  --yoj-border-strong: #a8a29e;
  --yoj-text: #292524;
  --yoj-text-secondary: #57534e;
  --yoj-text-muted: #78716c;
  --yoj-accent: #c2410c;
  --yoj-accent-strong: #c2410c;
  --yoj-ease: ease-in-out;

  --el-color-primary: #c2410c;
  --el-color-primary-light-3: #f97316;
  --el-color-primary-light-5: #fb923c;
  --el-color-primary-light-7: #fdba74;
  --el-color-primary-light-8: #ffedd5;
  --el-color-primary-light-9: #fff7ed;
  --el-color-primary-dark-2: #9a3412;
  --el-color-success: #047857;
  --el-color-success-light-3: #34d399;
  --el-color-success-light-5: #6ee7b7;
  --el-color-success-light-7: #a7f3d0;
  --el-color-success-light-8: #d1fae5;
  --el-color-success-light-9: #ecfdf5;
  --el-color-success-dark-2: #065f46;
  --el-color-warning: #b45309;
  --el-color-warning-light-3: #d97706;
  --el-color-warning-light-5: #fbbf24;
  --el-color-warning-light-7: #fde68a;
  --el-color-warning-light-8: #fef3c7;
  --el-color-warning-light-9: #fffbeb;
  --el-color-warning-dark-2: #92400e;
  --el-color-danger: #be123c;
  --el-color-danger-light-3: #fb7185;
  --el-color-danger-light-5: #fda4af;
  --el-color-danger-light-7: #fecdd3;
  --el-color-danger-light-8: #ffe4e6;
  --el-color-danger-light-9: #fff1f2;
  --el-color-danger-dark-2: #9f1239;
  --el-color-error: #be123c;
  --el-color-error-light-3: #fb7185;
  --el-color-error-light-5: #fda4af;
  --el-color-error-light-7: #fecdd3;
  --el-color-error-light-8: #ffe4e6;
  --el-color-error-light-9: #fff1f2;
  --el-color-error-dark-2: #9f1239;
  --el-color-info: #78716c;
  --el-color-info-light-3: #a8a29e;
  --el-color-info-light-5: #a8a29e;
  --el-color-info-light-7: #d6d3d1;
  --el-color-info-light-8: #f5f5f4;
  --el-color-info-light-9: #fafaf9;
  --el-color-info-dark-2: #57534e;
  --el-bg-color: #ffffff;
  --el-bg-color-page: #f5f5f4;
  --el-bg-color-overlay: #ffffff;
  --el-text-color-primary: #292524;
  --el-text-color-regular: #57534e;
  --el-text-color-secondary: #78716c;
  --el-text-color-placeholder: #78716c;
  --el-text-color-disabled: #a8a29e;
  --el-border-color: #d6d3d1;
  --el-border-color-light: #d6d3d1;
  --el-border-color-lighter: #e7e5e4;
  --el-border-color-extra-light: #f5f5f4;
  --el-fill-color: #f5f5f4;
  --el-fill-color-light: #fafaf9;
  --el-fill-color-lighter: #fafaf9;
  --el-fill-color-blank: #ffffff;
  --el-border-radius-base: 16px;
  --el-font-family: "Avenir Next", "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  min-width: 320px;
  background: var(--yoj-bg);
}

body {
  min-width: 320px;
  min-height: 100vh;
  font-family: var(--el-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--yoj-text);
  background: var(--yoj-bg);
}

#app {
  min-height: 100vh;
}

::selection {
  color: #7c2d12;
  background: #ffedd5;
}

::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

::-webkit-scrollbar-track {
  background: #fafaf9;
}

::-webkit-scrollbar-thumb {
  border: 2px solid #fafaf9;
  border-radius: 999px;
  background: #a8a29e;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a29e;
}

a {
  color: var(--yoj-accent-strong);
}

.el-button {
  --el-button-font-weight: 500;
  min-height: 44px;
  padding: 10px 20px;
  border: 0;
  border-radius: 16px;
  letter-spacing: 0.01em;
  transition: transform 200ms ease-in-out, box-shadow 200ms ease-in-out,
    color 200ms ease-in-out, background-color 200ms ease-in-out;
}

.el-button:not(.is-text):not(.is-link) {
  color: #44403c;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(168, 162, 158, 0.7), 0 4px 6px -4px rgba(168, 162, 158, 0.7);
}

.el-button--primary:not(.is-text):not(.is-link) {
  color: #ffffff;
  background: #c2410c;
  box-shadow: 0 10px 15px -3px rgba(194, 65, 12, 0.3), 0 4px 6px -4px rgba(194, 65, 12, 0.3);
}

.el-button--primary.is-plain:not(.is-text):not(.is-link) {
  color: #9a3412;
  background: #fff7ed;
  box-shadow: 0 10px 15px -3px rgba(194, 65, 12, 0.14);
}

.el-button--success:not(.is-text):not(.is-link) {
  color: #ffffff;
  background: #047857;
  box-shadow: 0 10px 15px -3px rgba(4, 120, 87, 0.24);
}

.el-button--danger:not(.is-text):not(.is-link) {
  color: #ffffff;
  background: #be123c;
  box-shadow: 0 10px 15px -3px rgba(190, 18, 60, 0.2);
}

.el-button.is-text,
.el-button.is-link {
  min-height: 44px;
  border-radius: 16px;
}

@media (hover: hover) {
  .el-button:not(.is-disabled):not(.is-loading):hover {
    transform: translateY(-2px);
    color: #9a3412;
    background: #ffffff;
    box-shadow: 0 20px 25px -5px rgba(194, 65, 12, 0.18), 0 8px 10px -6px rgba(194, 65, 12, 0.18);
  }

  .el-button--primary:not(.is-disabled):not(.is-loading):hover {
    color: #ffffff;
    background: #9a3412;
    box-shadow: 0 20px 25px -5px rgba(194, 65, 12, 0.3), 0 8px 10px -6px rgba(194, 65, 12, 0.3);
  }

  .el-button--primary.is-plain:not(.is-disabled):not(.is-loading):hover {
    color: #7c2d12;
    background: #ffedd5;
  }

  .el-button--success:not(.is-disabled):not(.is-loading):hover {
    color: #ffffff;
    background: #065f46;
  }

  .el-button--danger:not(.is-disabled):not(.is-loading):hover {
    color: #ffffff;
    background: #9f1239;
  }
}

.el-button:not(.is-disabled):not(.is-loading):active {
  transform: scale(0.95);
  box-shadow: inset 0 2px 4px rgba(41, 37, 36, 0.12);
}

.el-button.is-disabled,
.el-button.is-disabled:hover {
  opacity: 0.52;
}

.el-button:focus-visible,
a:focus-visible,
.el-menu-item:focus-visible,
[role="link"]:focus-visible {
  outline: 3px solid rgba(194, 65, 12, 0.4);
  outline-offset: 3px;
}

.el-input__wrapper,
.el-select__wrapper,
.el-textarea__inner {
  min-height: 44px;
  padding: 2px 16px;
  color: var(--yoj-text);
  border: 0;
  border-radius: 16px;
  background-color: #fafaf9;
  box-shadow: 0 0 0 1px #e7e5e4 inset;
  transition: box-shadow 200ms ease-in-out, background-color 200ms ease-in-out;
}

.el-textarea__inner {
  padding: 12px 16px;
}

.el-input__wrapper:hover,
.el-select__wrapper:hover,
.el-textarea__inner:hover {
  background-color: #f5f5f4;
  box-shadow: 0 0 0 1px #d6d3d1 inset;
}

.el-input__wrapper.is-focus,
.el-select__wrapper.is-focused,
.el-textarea__inner:focus {
  background-color: #ffffff;
  box-shadow: 0 0 0 1px #c2410c inset, 0 0 0 4px rgba(194, 65, 12, 0.16), 0 10px 25px -12px rgba(194, 65, 12, 0.3);
}

.el-input__inner,
.el-textarea__inner,
.el-select__selected-item,
.el-input-number .el-input__inner {
  color: var(--yoj-text);
}

.el-input__inner::placeholder,
.el-textarea__inner::placeholder {
  color: #78716c;
}

.el-input__prefix,
.el-input__suffix,
.el-select__caret,
.el-input-number__decrease,
.el-input-number__increase {
  color: var(--yoj-text-muted);
}

.el-input-number__decrease,
.el-input-number__increase {
  border: 0;
  background: #f5f5f4;
}

.el-card {
  --el-card-bg-color: #ffffff;
  --el-card-border-color: #d6d3d1;
  color: var(--yoj-text);
  border: 1px solid #d6d3d1;
  border-radius: 24px;
  box-shadow: 0 18px 36px -18px rgba(120, 113, 108, 0.42), 0 5px 14px -8px rgba(120, 113, 108, 0.32);
  transition: transform 300ms ease-in-out, box-shadow 300ms ease-in-out;
}

.el-card__header {
  border-bottom-color: #d6d3d1;
}

.el-table {
  --el-table-bg-color: #ffffff;
  --el-table-tr-bg-color: #ffffff;
  --el-table-header-bg-color: #fafaf9;
  --el-table-row-hover-bg-color: #fff7ed;
  --el-table-border-color: #f5f5f4;
  --el-table-text-color: #57534e;
  --el-table-header-text-color: #57534e;
  overflow: hidden;
  border: 1px solid #d6d3d1;
  border-radius: 16px;
}

.el-table th.el-table__cell {
  font-weight: 600;
  background: #fafaf9;
}

.el-table .el-table__cell {
  padding: 14px 0;
  border-bottom-color: #e7e5e4;
}

.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background: #fffdfc;
}

.el-table__inner-wrapper::before,
.el-table__border-left-patch {
  background-color: #e7e5e4;
}

.el-table__fixed-right,
.el-table__fixed {
  box-shadow: -8px 0 20px rgba(168, 162, 158, 0.5);
}

.el-pagination {
  --el-pagination-bg-color: #f5f5f4;
  --el-pagination-text-color: #57534e;
  --el-pagination-button-color: #57534e;
  --el-pagination-button-disabled-bg-color: #fafaf9;
  --el-pagination-hover-color: #c2410c;
  gap: 6px;
}

.el-pagination.is-background .el-pager li,
.el-pagination.is-background button {
  min-width: 40px;
  min-height: 40px;
  border: 0;
  border-radius: 14px;
}

.el-pagination.is-background .el-pager li.is-active {
  color: #ffffff;
  background: #c2410c;
  box-shadow: 0 10px 15px -3px rgba(194, 65, 12, 0.24);
}

.el-tag {
  border: 0;
  border-radius: 999px;
  font-weight: 500;
}

.el-tag--primary {
  color: #9a3412;
  background: #fff7ed;
}

.el-tag--success {
  color: #065f46;
  background: #ecfdf5;
}

.el-tag--warning {
  color: #92400e;
  background: #fffbeb;
}

.el-tag--danger {
  color: #9f1239;
  background: #fff1f2;
}

.el-tag--info {
  color: #57534e;
  background: #f5f5f4;
}

.el-dialog,
.el-message-box {
  color: var(--yoj-text);
  border: 1px solid #d6d3d1;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 25px 50px -12px rgba(120, 113, 108, 0.28);
}

.el-dialog__title,
.el-message-box__title {
  color: var(--yoj-text);
  font-weight: 600;
}

.el-message-box__content {
  color: var(--yoj-text-secondary);
}

.el-dialog__header,
.el-message-box__header {
  border-bottom: 1px solid #f5f5f4;
}

.el-dialog__header {
  padding-bottom: 18px;
}

.el-overlay {
  background: rgba(41, 37, 36, 0.28);
}

.el-message,
.el-notification {
  border: 0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 20px 25px -5px rgba(120, 113, 108, 0.22);
}

.el-message__content,
.el-notification__title,
.el-notification__content {
  color: var(--yoj-text-secondary);
}

.el-select-dropdown,
.el-picker-panel,
.el-popper.is-light {
  color: var(--yoj-text);
  border: 1px solid #d6d3d1;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 20px 25px -5px rgba(120, 113, 108, 0.22);
}

.el-select-dropdown__item {
  margin: 4px 8px;
  border-radius: 12px;
  color: var(--yoj-text-secondary);
}

.el-select-dropdown__item.is-hovering,
.el-select-dropdown__item.hover {
  color: var(--yoj-text);
  background: #f5f5f4;
}

.el-select-dropdown__item.is-selected {
  color: #9a3412;
  background: #fff7ed;
}

.el-form-item__label,
.el-divider__text,
.el-descriptions__label,
.el-descriptions__content {
  color: var(--yoj-text-secondary);
}

.el-form-item__error {
  color: #be123c;
}

.el-divider {
  border-color: #d6d3d1;
}

.el-divider__text {
  padding: 0 16px;
  color: var(--yoj-text);
  font-weight: 600;
  background: #ffffff;
}

.el-descriptions__body {
  color: var(--yoj-text-secondary);
  background: #ffffff;
}

.el-descriptions__cell {
  border-color: #d6d3d1 !important;
}

.el-empty__description p,
.el-result__subtitle {
  color: var(--yoj-text-muted);
}

.el-result__title {
  color: var(--yoj-text);
}

.el-skeleton__item {
  border-radius: 16px;
  background: linear-gradient(90deg, #f5f5f4 25%, #d6d3d1 37%, #f5f5f4 63%);
}

.el-loading-mask {
  border-radius: 24px;
  background-color: rgba(250, 250, 249, 0.82);
}

.el-alert {
  border: 0;
  border-radius: 16px;
}

.md-editor,
.md-editor-preview {
  --md-color: var(--yoj-text-secondary);
  --md-hover-color: var(--yoj-accent-strong);
  --md-bk-color: #ffffff;
  --md-border-color: #d6d3d1;
  --md-border-active-color: var(--yoj-accent);
}

.md-editor {
  border-radius: 16px;
}

.md-editor-preview {
  --md-theme-code-bk-color: #fafaf9;
  --md-theme-code-color: #44403c;
}


.md-editor .cm-activeLine {
  background: #fafaf9 !important;
}

.md-editor .cm-selectionBackground,
.md-editor .cm-focused .cm-selectionBackground {
  background: #fed7aa !important;
}

.md-editor .cm-cursor {
  border-left-color: #c2410c !important;
}

.md-editor .cm-gutters {
  color: #78716c !important;
  border-right: 1px solid #d6d3d1 !important;
  background: #fafaf9 !important;
}

.md-editor .cm-activeLineGutter {
  color: #9a3412 !important;
  background: #ffedd5 !important;
}

.md-editor .cm-keyword,
.md-editor-preview .hljs-keyword,
.md-editor-preview .hljs-selector-tag,
.md-editor-preview .hljs-name,
.md-editor-preview .hljs-tag {
  color: #9a3412 !important;
}

.md-editor .cm-string,
.md-editor-preview .hljs-string,
.md-editor-preview .hljs-attr,
.md-editor-preview .hljs-attribute,
.md-editor-preview .hljs-addition {
  color: #a16207 !important;
}

.md-editor .cm-number,
.md-editor-preview .hljs-number,
.md-editor-preview .hljs-literal,
.md-editor-preview .hljs-regexp {
  color: #be123c !important;
}

.md-editor .cm-comment,
.md-editor-preview .hljs-comment,
.md-editor-preview .hljs-quote {
  color: #78716c !important;
}

.md-editor .cm-typeName,
.md-editor .cm-className,
.md-editor .cm-propertyName,
.md-editor-preview .hljs-type,
.md-editor-preview .hljs-class,
.md-editor-preview .hljs-title,
.md-editor-preview .hljs-built_in {
  color: #047857 !important;
}

.md-editor .cm-operator,
.md-editor-preview .hljs-symbol,
.md-editor-preview .hljs-meta {
  color: #7c2d12 !important;
}

@media (max-width: 640px) {
  .el-dialog,
  .el-message-box {
    width: calc(100% - 32px) !important;
  }

  .el-pagination {
    flex-wrap: wrap;
    row-gap: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
